import { Redirect } from 'expo-router'

/** Legacy redirect — see ./terms.tsx for context. */
export default function PrivacyRedirect() {
  return <Redirect href={'/legal/privacy-policy' as never} />
}
